import topbarNotification from "@/components/topbarNotification";
import getPaid from "@/views/getPaidToShare";
import UserService from "@/services/user";
import DownloadApp from "@/components/downloadApp.vue";
import VideoService from "@/services/video";
import uploadNav from "./components/nav.vue";

export default {
  components: {
    topbarNotification,
    getPaid,
    DownloadApp,
    uploadNav,
  },

  data() {
    return {
      topBarContent: "Connect your Stripe account to start accepting payments",
      user: {},
      initAppDownload: false,
      isAppDownloadClicked: false,
      isSpotlightVideoAvailable: false,
    };
  },
  computed: {
    isStripeConnected() {
      return this.currentUser.stripe_connected;
    },
    onMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
    stripeLink() {
      return `https://connect.stripe.com/express/oauth/authorize?response_type=code&client_id=${process.env.STRIPE_CONNECT_CLIENT_ID}&scope=read_write&state=${this.$store.state.auth.secret_code}`;
    },
    isStreaming() {
      return (
        _.get(this.user.stream, "status", "") === "running" &&
        _.get(this.user.stream, "notified", false) &&
        (_.get(this.$store.state.streamPlayer.stream, "user.slug", "") !==
          this.user.slug ||
          !this.$store.getters["streamPlayer/hasFrame"])
      );
    },
  },
  methods: {
    broadcastLink() {
      if (this.isStreaming) {
        return this.$router.push({ name: "VideoManage" });
      } else {
        return this.$router.push({ name: "CreateLive" });
      }
    },
    setTab(pathName) {
      this.$router.push({ name: pathName });
    },
    onTab(tab) {
      if (tab.path) {
        this.$router.push({ name: tab.path });
      }
    },

    stripeLink() {
      return `https://connect.stripe.com/express/oauth/authorize?response_type=code&client_id=${process.env.STRIPE_CONNECT_CLIENT_ID}&scope=read_write&state=${this.$store.state.auth.secret_code}`;
    },

    getUser() {
      this.$store.dispatch("error/showLoadingActivity", true);
      UserService.getUserInfo(this.currentUser.username)
        .then((response) => {
          if (response.body.status !== "active") {
            this.$store.dispatch("error/showErrorToast", [
              "User does not exist",
            ]);
            this.$router.push({ path: "/" });
            return;
          }

          // console.log('profile init')
          this.user = response.body;
          this.$store.dispatch("error/showLoadingActivity", false);
        })
        .catch((e) => {
          this.$store.dispatch("error/showLoadingActivity", false);
          this.$store.dispatch("error/showErrorToast", ["Error fetching user"]);
        });
    },

    async isSpotlightAlreadyUploaded() {
      VideoService.spotlightVideoAvailable()
        .then((response) => {
          this.isSpotlightVideoAvailable = true;
        })
        .catch((e) => {
          this.isSpotlightVideoAvailable = false;
          this.$store.dispatch(
            "error/showErrorToast",
            e.body.errors || [e.body]
          );
        });
    },
  },
  watch: {
    initAppDownload(val) {
      if (val === false) {
        this.isAppDownloadClicked = true;
      }
    },
  },
  async created() {
    await this.getUser();
  },
};


// WEBPACK FOOTER //
// ./src/views/upload/index.ctrl.js